import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const licenseAPI = {
    async GetLicense(page,limit=15,startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/License/GetLicense?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },
    async GetLicenseCount(startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/License/GetLicenseCount?startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },

    async GetLicenseTotalCount(){
        const responseModel = await JwtAxios.get(`/License/GetLicenseTotalCount`);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/License/ExportExcel`,model);
        return responseModel
    },
}